var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.elementClass
  }, [_c('b-col', {
    staticClass: "datepicker-start-col"
  }, [_c('div', {
    staticClass: "label-wrapper"
  }, [_c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.filterId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm.hasHovertip ? _c('div', {
    staticClass: "hovertip-wrapper"
  }, [_vm.hasHovertip ? _c('img', {
    staticStyle: {
      "height": "0.75rem",
      "margin-left": "0.5rem"
    },
    attrs: {
      "id": _vm.getHovertipId,
      "src": _vm.hovertipSrc,
      "alt": "help"
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasHovertip ? _c('b-popover', {
    attrs: {
      "target": _vm.getHovertipId,
      "triggers": "hover focus"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.getHovertipTitle) + "\n          ")]), _vm._v("\n          " + _vm._s(_vm.getHovertipText) + "\n        ")], 2) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('datepicker', {
    class: _vm.inputClass,
    attrs: {
      "typeable": "",
      "clear-button": _vm.allowClear,
      "value": _vm.getValue,
      "required": _vm.elementRequired,
      "name": "Last Updated After",
      "placeholder": _vm.placeholder,
      "format": _vm.format,
      "use-utc": true
    },
    on: {
      "input": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _vm.dateBetween ? [_c('b-col', {
    staticClass: "datepicker-end-col"
  }, [_c('div', {
    staticClass: "label-wrapper"
  }, [_vm.dateBetween ? _c('label', [_vm._v(_vm._s(_vm.endLabel))]) : _vm._e()]), _vm._v(" "), _vm.dateBetween ? _c('datepicker', {
    staticClass: "chemtracker-container-date-filter",
    attrs: {
      "typeable": "",
      "clear-button": _vm.allowClear,
      "value": _vm.endDateGetValue,
      "required": _vm.elementRequired,
      "format": _vm.format,
      "use-utc": true
    },
    on: {
      "input": _vm.handleEndDateUpdate
    },
    model: {
      value: _vm.date2,
      callback: function ($$v) {
        _vm.date2 = $$v;
      },
      expression: "date2"
    }
  }) : _vm._e()], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }